<template>
  <div class="from-panel" ref="panel" v-loading="loading" element-loading-text="加载中...">
    <draggable :list="groups" group="group" handle=".el-icon-rank" filter=".undrag" @start="groupsSort = true"
               :options="{animation: 300 ,sort:true, scroll: true, chosenClass:'choose'}">
      <div :class="{'form-group':true, 'undrag': (group.id === 0 || group.id === undefined)}"
           v-show="group.id > 1 || group.children.length > 0 " v-for="(group) in groups" :key="group.id">
        <div class="form-group-title">
          <span>{{group.name}}</span>
          <span>/ {{group.children.length}}</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-around">
          <div :class="{'form-group-item':true, 'undrag': item.isStop}" v-for="(item, index) in group.children" :key="item.id || `${group.id}-${index}`" >
            <div style="width: 100%"  @click="enterItem(item)">
              <div class="picture" :class="item.logo.icon" :style="'background: '+item.logo.background"></div>
              <div class="exceed" :title="item.formName">{{item.formName}}</div>
            </div>
          </div>
          <div style="width: 130px;" v-for="(item) in 10" :key="item"></div>
        </div>
      </div>
    </draggable>
    <!-- 没有可申请的表单时的空状态（加载完成后才显示，避免加载中闪一下） -->
    <el-empty v-if="!loading && !hasForm" description="没有可以申请的表单！"></el-empty>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {getFormGroups} from '@/api/design'
import '/src/assets/styles.css';
export default {
  name: "index",
  components: {draggable},
  data() {
    return {
      // 表单分组加载态
      loading: true,
      openItemDl: false,
      selectForm: {},
      moveSelect: '',
      visible: false,
      groupsSort: false,
      groups: []
    }
  },
  created() {
    var ps=document.getElementById('sb');
    if (ps!=null){
      ps.forEach((p) => {
        let len = p.getTotalLength();
        len.style.setPriority('--l',len);
      })
    }
  },
  mounted: function () {
    this.getGroups();
  },
  computed: {
    // 是否有可申请的表单（任一分组下有表单项即算有）
    hasForm() {
      return (this.groups || []).some(group => group.children && group.children.length > 0);
    },
  },
  methods: {
    enterItem(item) {
      this.$router.push({
        path: "/oa/startApply",
        query: {
          selectForm: item,
        },
      });
    },
    getGroups() {
      this.loading = true;
      getFormGroups().then(rsp => {
        this.groups = rsp.data;
      }).catch(() => {
        this.$message.error('表单分组加载失败，请稍后重试');
      }).finally(() => {
        this.loading = false;
      })
    },
  }
}
</script>
<style lang="less" scoped>

body {
  background: #ffffff !important;
}

.undrag {
  background: #ebecee !important;
}

.from-panel {
  min-width: 800px;
  /* 数据未加载时也留出高度，保证 loading 遮罩可见 */
  min-height: 60vh;
  background: #ffffff;
  /deep/ .from-title {
    div {
      float: right;

      .el-button {
        border-radius: 15px;
      }
    }
  }

  //height: 100vh;
}

.choose {
  background: #e9ebee;
}
.picture{
  width: 44px;
  height: 44px;
  line-height: 44px;
  border-radius: 10px;
  font-size: 20px;
  color: #ffffff;
  margin: 0 auto;
}

.exceed{
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏超出的内容 */
  text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
  max-width: 200px; /* 设置最大宽度以限制文本的显示长度 */
  margin: 8px 0;
}
.form-group {
  margin-bottom: 20px;
  border-radius: 10px;
  padding:16px 16px 6px 16px;
  background: #F5F7FA;
  .form-group-title {
    padding-bottom: 6px;
    .el-icon-rank {
      display: none;
      cursor: move;
    }
    &:hover {
      .el-icon-rank {
        display: inline-block;
      }
    }
    div {
      display: inline-block;
      float: right;
    }

    span:first-child {
      margin-right: 5px;
      font-size: 15px;
      font-weight: bold;
    }

    span:nth-child(2) {
      color: #656565;
      font-size: small;
      margin-right: 10px;
    }

    /deep/ .el-button {
      color: #404040;
      margin-left: 20px;

      &:hover {
        color: #2b2b2b;
      }
    }
  }

  .form-group-item:nth-child(1) {
    border-top: none !important;
  }

  .form-group-item {
    color: #3e3e3e;
    font-size: 14px;
    padding:16px 10px 10px 10px;
    margin: 10px;
    width: 90px;
    min-width: 90px;
    background-color: white;
    border-radius: 12px;
    text-align: center;
  }
}

@media screen and (max-width: 1000px) {
  .desp {
    display: none !important;
  }
}

@media screen and (max-width: 800px) {
  .from-panel{
    padding: 20px 10px;
  }
}
</style>
